$.events = {
	ticket: {
		callback: {
			change: {
				success: function(data) {
					$.events.ticket.pull.getBasketData(data.eventId);
				}
			},

			getBasketData: {
				success: function(data) {
					$.each(data.tickets, function(index, value) {
						$('#ticket-total-price-'+ value.ticketId).html(value.total);
					});

					$('#ticketBasketSubTotal').html(data.total.subtotal);
					$('#ticketBasketFee').html(data.total.fee);
					$('#ticketBasketTotal').html(data.total.total);
				}
			},

			buyGotoInfoPages: {
				success: function(data) {
					location.href = '/basket/checkout';
				}
			}
		},

		pull: {
			getBasketData: function(eventId) {
				$('#dialogToolbar').ajax_callback('/json/event/ticket/getBasketData',{
					'eventId' : eventId
				}, {
					alertToolbar: false,
					callback_success: $.events.ticket.callback.getBasketData.success
				});
			}
		},

		push: {
			updateTicket: function(eventId, ticketId, ticketAmount) {
				$('#dialogToolbar').ajax_callback('/json/event/ticket/change',{
					'eventId' : eventId,
					'ticketId' : ticketId,
					'amount' : ticketAmount,
				}, {
					alertToolbar: false,
					callback_success: $.events.ticket.callback.change.success
				});
			},

			buyGotoInfoPages: function(eventId) {
				$('#dialogToolbar').ajax_callback('/json/event/ticket/buyGoToNext',{
					'eventId' : eventId
				}, {
					alertToolbar: false,
					callback_success: $.events.ticket.callback.buyGotoInfoPages.success
				});
			}
		}
	}
};
